import { css } from '@emotion/react';
import { center, borderRadius } from '@atlaskit/media-ui';
import { N20, N50 } from '@atlaskit/theme/colors';
export var wrapperStyles = function wrapperStyles(_ref) {
  var dimensions = _ref.dimensions;
  return css(center, {
    background: "var(--ds-background-neutral, ".concat(N20, ")"),
    color: "var(--ds-icon, ".concat(N50, ")")
  }, borderRadius, {
    maxHeight: '100%',
    maxWidth: '100%',
    width: dimensions.width,
    height: dimensions.height
  });
};